<template>
  <el-container class="doc" direction='vertical'>
   <div class="search-container">
      <div class="v-search-btn">
        <el-date-picker value-format="yyyy-MM" class="v-date" v-model="month" type="month" align="right" placeholder="选择月份">
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="getMemberStatistics" size="medium">查询</el-button>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table v-loading="isLoading" :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" label="新增会员">
              <template slot-scope="scope">
                <span>{{ scope.row.new_member_count }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="充值人数">
              <template slot-scope="scope">
                <span>{{ scope.row.recharge_count }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="续卡人数">
              <template slot-scope="scope">
                <span>{{ scope.row.again_count }} </span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
    </el-container>
  </el-container>
</template>
<script>
import dayjs from 'dayjs'
import { memberByMonth } from '@/views/webpc/MemberStatistics/overviewApp/apis'
export default {
  data () {
    return {
      isLoading: false,
      month: dayjs().format('YYYY-MM'),
      tableData: []
    }
  },
  methods: {
    // 会员统计
    getMemberStatistics () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      if (this.month) {
        data.append('month', this.month)
      }
      memberByMonth(data)
        .then((result) => {
          this.isLoading = false
          if (result) {
            if (result) {
              this.isLoading = false
              let res = result.data
              this.tableData = [
                {
                  new_member_count: res.new_member_count,
                  recharge_count: res.recharge_count,
                  again_count: res.again_count
                }
              ]
            }
          }
        })
        .catch((error) => {
          if (error) {
            this.isLoading = false
          }
        })
    }
  },
  mounted () {
    this.getMemberStatistics()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/MemberStatistics/overviewApp/overview.vue